import { Button } from "@/components/ui/button";
import { AlertTriangle, MoveRight, Ban, RotateCcw, Trash2 } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { groupByMonth, fmtDate, lastEdit } from "./calendarUtils";

const LessonRow = ({ x, showCourse, overlap, actions }) => (
  <li data-testid={`lesson-${x.id}`} className={`p-3 flex flex-col sm:flex-row sm:items-center gap-2 ${x.status === "cancelled" ? "opacity-60" : ""}`}>
    <div className="flex-1 min-w-0">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-foreground font-medium capitalize">{fmtDate(x.date)}</span>
        <span className="text-sm text-muted-foreground">{x.start_time}–{x.end_time}</span>
        <StatusBadge status={x.status} testid={`lesson-status-${x.id}`} />
      </div>
      {x.original_date && x.status !== "regular" && (x.original_date !== x.date || x.original_start_time !== x.start_time) && (
        <p className="text-xs text-muted-foreground mt-0.5" data-testid={`lesson-original-${x.id}`}>Data originale: {fmtDate(x.original_date)} · {x.original_start_time}</p>
      )}
      {showCourse && <p className="text-xs text-muted-foreground mt-0.5 break-words">{x.course} · {x.teacher_name || "Docente non indicato"}</p>}
      {x.updated_by && <p className="text-xs text-muted-foreground mt-0.5" data-testid={`lesson-lastedit-${x.id}`}>{lastEdit(x)}</p>}
      {overlap && <p className="text-xs text-amber-700 mt-0.5 flex items-center gap-1" data-testid={`lesson-overlap-${x.id}`}><AlertTriangle size={12} /> Docente con un'altra lezione sovrapposta</p>}
    </div>
    {actions && (
      <div className="flex flex-wrap gap-1.5">
        {x.status !== "cancelled" && <Button size="sm" variant="outline" data-testid={`lesson-move-${x.id}`} onClick={() => actions.move(x)}><MoveRight size={14} className="mr-1" /> Sposta</Button>}
        {x.status !== "cancelled"
          ? <Button size="sm" variant="outline" data-testid={`lesson-cancel-${x.id}`} onClick={() => actions.cancel(x)}><Ban size={14} className="mr-1" /> Annulla</Button>
          : <Button size="sm" variant="outline" data-testid={`lesson-restore-${x.id}`} onClick={() => actions.restore(x)}><RotateCcw size={14} className="mr-1" /> Ripristina</Button>}
        {x.origin === "recovery" && <Button size="icon" variant="ghost" data-testid={`lesson-delete-${x.id}`} onClick={() => actions.remove(x)} className="text-destructive hover:text-destructive h-8 w-8"><Trash2 size={14} /></Button>}
      </div>
    )}
  </li>
);

export const LessonList = ({ lessons, showCourse = false, overlaps, actions }) => (
  <div className="space-y-5">
    {groupByMonth(lessons).map((g) => (
      <div key={g.key} data-testid={`lessons-month-${g.key}`}>
        <h4 className="text-sm uppercase tracking-wide text-muted-foreground mb-2">{g.label} <span className="normal-case">· {g.items.filter((x) => x.status !== "cancelled").length} lezioni</span></h4>
        <ul className="divide-y divide-border border border-border rounded-lg bg-card">
          {g.items.map((x) => <LessonRow key={x.id} x={x} showCourse={showCourse} overlap={overlaps?.has(x.id)} actions={actions} />)}
        </ul>
      </div>
    ))}
  </div>
);
